/* eslint-disable no-console */
/* eslint-disable operator-assignment */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable no-unused-vars */
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  List,
  MenuItem,
  Select,
} from '@material-ui/core';
import moment from 'moment';
// @ts-ignore
import pt from 'moment/locale/pt-br';
import React, { useEffect, useState, useRef } from 'react';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';
import { RootStateOrAny, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import NavCommon from '../../components/navCommon';
import Container from '../../components/container';
import ItemListModal from '../../components/itemListModal';
import {
  ScheduleCurrent, ScheduleTurn, UserPlatform, UserState,
} from '../../interfaces';
import axios from '../../services/axiosServicesAgendamentos';
import axiosUsers from '../../services/axiosServicesUsers';
import { calendar, nextCalendar } from '../../utils/dayOfWeek';
import {
  Block,
  CardContainer,
  ContainerBlocok,
  ContainerColumBlock,
  ContainerExt,
  ContainerLoading,
  DayByTurnContainer,
  DayContainer,
  DayHeader,
  Days,
  DayText,
  ScheduleContainer,
  ScheduleContainerColumn,
  TitleImovel,
  TurnText,
} from './styles';
import Corretores from './corretores';
import enviroment from '../../enviroments';
import LoadingCommon from '../../components/LoadingCommon';

const Schedule = () => {
  const history = useHistory();
  const { token: TOKEN } = useSelector<RootStateOrAny, UserState>((state) => state.user);
  const [loading, setLoading] = useState<boolean>(false);
  const [currentSchedule, setCurrentSchedule] = useState<ScheduleCurrent>();
  const [dataSchedule, setDataSchedule] = useState<ScheduleTurn>();
  const [usersPlatform, setUsers] = useState<Array<UserPlatform>>([]);
  const [open, setOpen] = useState<boolean>(false);
  const [openSchedule, setOpenSchedule] = useState<boolean>(false);
  const [loadingSave, setloadingSave] = useState<boolean>(false);
  const [idTurnoAgenda, setIdTurnoAgenda] = useState<string>();
  const [hubAgendamentoConn, setHubAgendamentoConn] = useState<null | HubConnection>(null);
  const [option, setOption] = useState(10);
  const [corretores, setCorretores] = useState<Array<any>>();
  const [calendars, setCalendar] = useState<Array<any>>();
  const [daysWeek, setDaysWeek] = useState<Array<string> | null>();
  const [state, setNewState] = useState<string>();
  const [lastWeekId, setLastWeekid] = useState<string>();
  const [nextWeekId, setNextWeekId] = useState<string>();
  const [currentWeekId, setCurrentWeekId] = useState<string>();
  const latestChat = useRef(null);
  const lastWeek = useRef(null);
  const nextWeek = useRef(null);
  // @ts-ignore
  latestChat.current = state;
  // @ts-ignore
  lastWeek.current = lastWeekId;
  // @ts-ignore
  nextWeek.current = nextWeekId;

  useEffect(() => {
    setNewState('current');
    setCalendar(calendar);
  }, []);

  useEffect(() => {
    const baseURL = `${enviroment.API_URL_AGENDAMENTO_RESERVA}hubs/agendamento/`;
    const connect = new HubConnectionBuilder()
      .withUrl(baseURL, {
        accessTokenFactory: () => TOKEN,
      })
      .withAutomaticReconnect()
      .build();

    setHubAgendamentoConn(connect);
  }, []);

  useEffect(() => {
    if (!hubAgendamentoConn) {
      return;
    }
    hubAgendamentoConn
      .start()
      .then(() => {
        hubAgendamentoConn.on('AtualizacaoTurno', (response) => {});
      })
      .catch((error) => {
      });
  }, [hubAgendamentoConn]);

  useEffect(() => {
    getUsers();
    setLoading(true);
    getScheduleCurrent();
  }, []);

  const getScheduleCurrent = async () => {
    try {
      const response = await axios.get('admin/agendas/reserva-posicao/v1/turnos');
      const value: ScheduleTurn = response?.data?.data;
      setNewState('current');

      setLastWeekid(value.idAgendaAnterior);
      setNextWeekId(value.idAgendaSubsequente || '');
      setCurrentWeekId(value.idAgenda);

      generateDays(value.dataInicioAgenda);

      value.locais.sort(
        (a, b) => ((a.nomeLocal > b.nomeLocal) ? 1 : -1),
      );

      value.locais.map((item) => {
        item.turnosAgenda.sort(
          (a, b) => ((a.data > b.data) ? 1 : -1),
        );
        return item;
      });

      setDataSchedule(value);
      setLoading(false);
    } catch (error: any) {
      toast.error(`⚠ ${error?.response.data?.notifications?.map((item: any) => `${item.message}\n`)}`);
      setLoading(false);
    }
  };

  const getScheduleNextWeek = async () => {
    try {
      if (!nextWeek) return;

      setNewState('nextweek');
      const response = await axios.get(`/admin/agendas/reserva-posicao/v1/turnos/?IdAgenda=${nextWeek.current}`);
      const value: ScheduleTurn = response?.data?.data;

      generateDays(value.dataInicioAgenda);

      value.locais.map((item) => {
        item.turnosAgenda.sort(
          (a, b) => ((a.data > b.data) ? 1 : -1),
        );
        return item;
      });

      setDataSchedule(value);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const getScheduleLastWeek = async () => {
    try {
      if (!lastWeek) return;

      setNewState('lastweek');
      const response = await axios.get(`/admin/agendas/reserva-posicao/v1/turnos/?IdAgenda=${lastWeek.current}`);
      const value: ScheduleTurn = response?.data?.data;

      generateDays(value.dataInicioAgenda);

      value.locais.map((item) => {
        item.turnosAgenda.sort(
          (a, b) => ((a.data > b.data) ? 1 : -1),
        );
        return item;
      });

      setDataSchedule(value);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const generateDays = (day: string) => {
    const days: string[] = [
      moment(day).format('YYYY-MM-DD'),
      moment(day).add(1, 'day').format('YYYY-MM-DD'),
      moment(day).add(2, 'day').format('YYYY-MM-DD'),
      moment(day).add(3, 'day').format('YYYY-MM-DD'),
      moment(day).add(4, 'day').format('YYYY-MM-DD'),
      moment(day).add(5, 'day').format('YYYY-MM-DD'),
      moment(day).add(6, 'day').format('YYYY-MM-DD'),
    ];
    setDaysWeek(days);
  };

  const getUsers = async () => {
    try {
      const payload: {
        PaginaAtual: number;
        TotalItensRetorno: number;
        CodigoCategoriaLocal?: number | undefined
      } = {
        PaginaAtual: 1,
        TotalItensRetorno: 20,
      };

      const response = await axiosUsers.get('admin/usuarios/v1', { params: payload });
      const { data: dataUSers } = response.data;

      setUsers(dataUSers.sort(
        (a: any, b: any) => ((a.nome > b.nome) ? 1 : -1),
      ));
    } catch (err: any) {
      toast.error(`⚠ ${err?.data?.notifications?.map((item: any) => `${item.message}\n`) || err?.data.message}`);
    }
  };

  const getScheduleFromCorretor = async () => {
    try {
      const response = await axios.get(`admin/agendas/reserva-posicao/v1/agrupados-por-usuario-e-categoria/${currentWeekId}`);
      const value = response.data?.data;

      value.sort(
        (a: any, b: any) => ((a.nome > b.nome) ? 1 : -1),
      );
      setCorretores(value);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const cancelPositition = (_idTurnoAgenda: string, idUsuario: string) => {
    try {
      Swal.fire({
        title: 'Atenção!',
        text: 'Você tem certeza que deseja cancelar essa posição ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: 'Cancelando',
            html: '<b></b>',
            timerProgressBar: true,
            didOpen: async () => {
              try {
                Swal.showLoading();
                await cancelReservation(_idTurnoAgenda, idUsuario);
                Swal.close();
                if (state === 'current') {
                  getScheduleCurrent();
                } else if (state === 'nextweek') {
                  getScheduleNextWeek();
                } else if (state === 'lastweek') {
                  getScheduleLastWeek();
                }
              } catch (error) {
                console.log(error);
              }
            },
          });
        }
      });
    } catch (error) {
      toast.error('Ops');
    }
  };

  const formateDate = (day: string): string => moment(day).format('DD/MM');

  const checkItem = (id: String) => {
    setUsers(
      usersPlatform?.map((item) => {
        if (id === item.id) {
          item.check = true;
          return item;
        }
        item.check = false;
        return item;
      }),
    );
  };

  const unCheck = () => {
    setUsers(
      usersPlatform?.map((item) => {
        item.check = false;
        return item;
      }),
    );
  };

  const cancelReservation = async (_idTurnoAgenda: string, idUsuarioPosicao: string) => {
    try {
      await axios.put(`admin/agendas/reserva-posicao/v1/cancelar-reserva/${_idTurnoAgenda}/${idUsuarioPosicao}`);
    } catch (err: any) {
      toast.error(`⚠ ${err?.data?.notifications?.map((item: any) => `${item.message}\n`) || err?.data.message}`);
    }
  };

  const reserverPostion = async (idUsuarioParaPosicao: string) => {
    try {
      setloadingSave(true);
      await axios.post('admin/agendas/reserva-posicao/v1', {
        idTurnoAgenda,
        idUsuarioParaPosicao,
      });

      const checkState = latestChat.current;

      if (checkState === 'current') {
        getScheduleCurrent();
      } if (checkState === 'nextweek') {
        getScheduleNextWeek();
      } if (checkState === 'lastweek') {
        getScheduleLastWeek();
      }

      setOpenSchedule(false);
      setloadingSave(false);
      setIdTurnoAgenda('');
      unCheck();
      toast.success('Posição reservada com sucesso!');
    } catch (err: any) {
      setloadingSave(false);
      toast.error(`⚠ ${err?.data?.notifications?.map((item: any) => `${item.message}\n`) || err?.data.message}`);
    }
  };

  function modalNewSchedule() {
    return (
      <Dialog open={openSchedule}>
        <DialogTitle>Reservar posição</DialogTitle>
        <DialogContent>
          <strong style={{ marginBottom: 100 }}>Selecione o corretor:</strong>
          <div style={{ height: 10 }} />
          <List dense={false} style={{ height: '100%' }}>
            {usersPlatform?.map((item: UserPlatform) => {
              const labelId = `checkbox-list-secondary-label-${item.id}`;
              return (
                <ItemListModal
                  id={item.id}
                  imagem={item.nomeFotoUsuario}
                  nome={item.nome}
                  labelId={labelId}
                  check={item.check || false}
                  action={() => {
                    checkItem(item.id);
                  }}
                />
              );
            })}
          </List>
        </DialogContent>
        <DialogActions style={{ width: '100%' }}>
          {!loadingSave && (
            <Button
              onClick={() => {
                setIdTurnoAgenda('');
                unCheck();
                setOpenSchedule(false);
              }}
              color="primary"
            >
              Fechar
            </Button>
          )}
          {loadingSave ? (
            <div style={{ marginRight: 30, marginLeft: 20 }}>
              <LoadingCommon />
            </div>
          ) : (
            <Button
              style={{ marginRight: 10 }}
              onClick={async () => {
                const user: UserPlatform = usersPlatform.filter((item) => item.check)[0];
                if (user) {
                  await reserverPostion(user.id);
                }
              }}
              color="primary"
            >
              Salvar
            </Button>
          )}
        </DialogActions>
      </Dialog>
    );
  }

  const handleChange = (event: any) => {
    setOption(event.target.value);

    if (event.target.value === 20) {
      setLoading(true);
      getScheduleFromCorretor();
    }
  };

  return (
    <>
      <NavCommon
        breadcrumbs={[]}
        hasOnChange={false}
        onBack={() => { history.goBack(); }}
        onChange={() => {

        }}
      />
      <ContainerExt>
        <Container component="div" maxWidth="xl">
          <div>
            {modalNewSchedule()}
            {loading ? (
              <ContainerLoading>
                <LoadingCommon />
              </ContainerLoading>
            ) : (
              <>
                {option === 10 ? (
                  <CardContainer>
                    <div style={{ display: 'flex', flexDirection: 'row', marginLeft: option === 10 ? 20 : 0 }}>
                      <FormControl variant="outlined" style={{ width: '30%', marginTop: 80 }}>
                        <InputLabel id="demo-simple-select-outlined-label">Filtro</InputLabel>
                        <Select
                          labelId="demo-simple-select-outlined-label"
                          id="demo-simple-select-outlined"
                          value={option}
                          defaultValue={option}
                          onChange={handleChange}
                          label="Age"
                        >
                          <MenuItem value="">
                            <em />
                          </MenuItem>
                          <MenuItem value={10}>Reserva</MenuItem>
                          <MenuItem value={20}>Lista de corretores</MenuItem>
                        </Select>
                      </FormControl>
                      {option === 10 && (
                      <div style={{
                        height: 60,
                        width: '100%',
                        marginTop: 80,
                        marginLeft: 20,
                        flexDirection: 'row',
                        display: 'flex',
                      }}
                      >
                        <Button
                          color={state === 'lastweek' ? 'primary' : 'default'}
                          style={{ height: 54, marginRight: 10 }}
                          onClick={() => {
                            if (!lastWeekId) {
                              toast.info('Não há agenda para a semana anterior!');
                              return;
                            }
                            setLoading(true);
                            getScheduleLastWeek();
                          }}
                          variant="contained"
                        >
                          Semana anterior
                        </Button>
                        <Button
                          color={state === 'current' ? 'primary' : 'default'}
                          style={{ height: 54, marginRight: 10 }}
                          onClick={() => {
                            getScheduleCurrent();
                          }}
                          variant="contained"
                        >
                          Semana atual
                        </Button>
                        <Button
                          color={state === 'nextweek' ? 'primary' : 'default'}
                          style={{ height: 54 }}
                          onClick={() => {
                            if (!nextWeekId) {
                              toast.info('Não há agenda para próxima semana!');
                              return;
                            }
                            getScheduleNextWeek();
                          }}
                          variant="contained"
                        >
                          Próxima semana
                        </Button>
                      </div>
                      )}
                    </div>
                    <ScheduleContainerColumn style={{ marginLeft: 20 }}>
                      <ScheduleContainer style={{ marginTop: 20 }}>
                        <TitleImovel style={{ marginRight: 4 }}>
                          IMÓVEL
                        </TitleImovel>
                        <DayContainer>
                          {calendars?.map((it, index: number) => (
                            <Days style={{ marginRight: 10 }}>
                              <DayHeader>{daysWeek ? formateDate(daysWeek[index]) : ''}</DayHeader>
                              <DayText>{it.dia}</DayText>
                              <DayByTurnContainer>
                                <TurnText style={{ marginLeft: 4 }}>
                                  MAN
                                </TurnText>
                                <TurnText>
                                  TAR
                                </TurnText>
                                <TurnText>
                                  NOT
                                </TurnText>
                              </DayByTurnContainer>
                            </Days>
                          ))}
                        </DayContainer>
                      </ScheduleContainer>
                      <ScheduleContainerColumn style={{ marginTop: 0, marginBottom: 20 }}>
                        {dataSchedule?.locais.map((item) => (
                          <ScheduleContainer style={{ marginTop: 20 }}>
                            <TitleImovel style={{ marginRight: 4 }}>
                              {item.nomeLocal}
                            </TitleImovel>
                            <DayContainer>
                              {/* TERC */}
                              <ContainerBlocok>
                                <DayByTurnContainer>
                                  <ContainerColumBlock>
                                    {item.turnosAgenda.map((it) => {
                                      if (it.codigoDiaSemana === 2 && it.codigoTipoTurno === 1) {
                                        const users = it.usuarios;
                                        return users.map((user) => (
                                          <Block
                                            onClick={() => {
                                              cancelPositition(it.idTurnoAgenda, user.idUsuario);
                                            }}
                                            style={{ backgroundColor: '#7a7a7a', color: 'white' }}
                                          >
                                            {user.siglaNomeUsuario}

                                          </Block>
                                        ));
                                      }
                                    })}
                                    {item.turnosAgenda.map((it) => {
                                      if (it.codigoDiaSemana === 2 && it.codigoTipoTurno === 1) {
                                        const position = Array(
                                          it.quantidadePosicoesDisponiveis,
                                        ).fill(null);
                                        if (position.length > 0) {
                                          return position.map((_) => (
                                            <Block onClick={() => {
                                              setIdTurnoAgenda(it.idTurnoAgenda);
                                              setOpenSchedule(true);
                                            }}
                                            >
                                              {' '}

                                            </Block>
                                          ));
                                        }
                                      }
                                    })}
                                  </ContainerColumBlock>
                                  <ContainerColumBlock>
                                    {item.turnosAgenda.map((it) => {
                                      if (it.codigoDiaSemana === 2 && it.codigoTipoTurno === 2) {
                                        const users = it.usuarios;
                                        return users.map((user) => (
                                          <Block
                                            onClick={() => {
                                              cancelPositition(it.idTurnoAgenda, user.idUsuario);
                                            }}
                                            style={{ backgroundColor: '#7a7a7a', color: 'white' }}
                                          >
                                            {user.siglaNomeUsuario}

                                          </Block>
                                        ));
                                      }
                                    })}
                                    {item.turnosAgenda.map((it) => {
                                      if (it.codigoDiaSemana === 2 && it.codigoTipoTurno === 2) {
                                        const position = Array(
                                          it.quantidadePosicoesDisponiveis,
                                        ).fill(null);
                                        if (position.length > 0) {
                                          return position.map((_) => (
                                            <Block onClick={() => {
                                              setIdTurnoAgenda(it.idTurnoAgenda);
                                              setOpenSchedule(true);
                                            }}
                                            >
                                              {' '}

                                            </Block>
                                          ));
                                        }
                                      }
                                    })}
                                  </ContainerColumBlock>
                                  <ContainerColumBlock>
                                    {item.turnosAgenda.map((it) => {
                                      if (it.codigoDiaSemana === 2 && it.codigoTipoTurno === 3) {
                                        const users = it.usuarios;
                                        return users.map((user) => (
                                          <Block
                                            onClick={() => {
                                              cancelPositition(it.idTurnoAgenda, user.idUsuario);
                                            }}
                                            style={{ backgroundColor: '#7a7a7a', color: 'white' }}
                                          >
                                            {user.siglaNomeUsuario}

                                          </Block>
                                        ));
                                      }
                                    })}
                                    {item.turnosAgenda.map((it) => {
                                      if (it.codigoDiaSemana === 2 && it.codigoTipoTurno === 3) {
                                        const position = Array(
                                          it.quantidadePosicoesDisponiveis,
                                        ).fill(null);
                                        if (position.length > 0) {
                                          return position.map((_) => (
                                            <Block onClick={() => {
                                              setIdTurnoAgenda(it.idTurnoAgenda);
                                              setOpenSchedule(true);
                                            }}
                                            >
                                              {' '}

                                            </Block>
                                          ));
                                        }
                                      }
                                    })}
                                  </ContainerColumBlock>
                                </DayByTurnContainer>
                              </ContainerBlocok>
                              {/* QUART */}
                              <ContainerBlocok>
                                <DayByTurnContainer>
                                  <ContainerColumBlock>
                                    {item.turnosAgenda.map((it) => {
                                      if (it.codigoDiaSemana === 3 && it.codigoTipoTurno === 1) {
                                        const users = it.usuarios;
                                        return users.map((user) => (
                                          <Block
                                            onClick={() => {
                                              cancelPositition(it.idTurnoAgenda, user.idUsuario);
                                            }}
                                            style={{ backgroundColor: '#7a7a7a', color: 'white' }}
                                          >
                                            {user.siglaNomeUsuario}

                                          </Block>
                                        ));
                                      }
                                    })}
                                    {item.turnosAgenda.map((it) => {
                                      if (it.codigoDiaSemana === 3 && it.codigoTipoTurno === 1) {
                                        const position = Array(
                                          it.quantidadePosicoesDisponiveis,
                                        ).fill(null);
                                        if (position.length > 0) {
                                          return position.map((_) => (
                                            <Block onClick={() => {
                                              setIdTurnoAgenda(it.idTurnoAgenda);
                                              setOpenSchedule(true);
                                            }}
                                            >
                                              {' '}

                                            </Block>
                                          ));
                                        }
                                      }
                                    })}
                                  </ContainerColumBlock>
                                  <ContainerColumBlock>
                                    {item.turnosAgenda.map((it) => {
                                      if (it.codigoDiaSemana === 3 && it.codigoTipoTurno === 2) {
                                        const users = it.usuarios;
                                        return users.map((user) => (
                                          <Block
                                            onClick={() => {
                                              cancelPositition(it.idTurnoAgenda, user.idUsuario);
                                            }}
                                            style={{ backgroundColor: '#7a7a7a', color: 'white' }}
                                          >
                                            {user.siglaNomeUsuario}

                                          </Block>
                                        ));
                                      }
                                    })}
                                    {item.turnosAgenda.map((it) => {
                                      if (it.codigoDiaSemana === 3 && it.codigoTipoTurno === 2) {
                                        const position = Array(
                                          it.quantidadePosicoesDisponiveis,
                                        ).fill(null);
                                        if (position.length > 0) {
                                          return position.map((_) => (
                                            <Block onClick={() => {
                                              setIdTurnoAgenda(it.idTurnoAgenda);
                                              setOpenSchedule(true);
                                            }}
                                            >
                                              {' '}

                                            </Block>
                                          ));
                                        }
                                      }
                                    })}
                                  </ContainerColumBlock>
                                  <ContainerColumBlock>
                                    {item.turnosAgenda.map((it) => {
                                      if (it.codigoDiaSemana === 3 && it.codigoTipoTurno === 3) {
                                        const users = it.usuarios;
                                        return users.map((user) => (
                                          <Block
                                            onClick={() => {
                                              cancelPositition(it.idTurnoAgenda, user.idUsuario);
                                            }}
                                            style={{ backgroundColor: '#7a7a7a', color: 'white' }}
                                          >
                                            {user.siglaNomeUsuario}

                                          </Block>
                                        ));
                                      }
                                    })}
                                    {item.turnosAgenda.map((it) => {
                                      if (it.codigoDiaSemana === 3 && it.codigoTipoTurno === 3) {
                                        const position = Array(
                                          it.quantidadePosicoesDisponiveis,
                                        ).fill(null);
                                        if (position.length > 0) {
                                          return position.map((_) => (
                                            <Block onClick={() => {
                                              setIdTurnoAgenda(it.idTurnoAgenda);
                                              setOpenSchedule(true);
                                            }}
                                            >
                                              {' '}

                                            </Block>
                                          ));
                                        }
                                        return <Block style={{ backgroundColor: 'transparent' }}>{' '}</Block>;
                                      }
                                    })}
                                  </ContainerColumBlock>
                                </DayByTurnContainer>
                              </ContainerBlocok>
                              {/* QUIN */}
                              <ContainerBlocok>
                                <DayByTurnContainer>
                                  <ContainerColumBlock>
                                    {item.turnosAgenda.map((it) => {
                                      if (it.codigoDiaSemana === 4 && it.codigoTipoTurno === 1) {
                                        const users = it.usuarios;
                                        return users.map((user) => (
                                          <Block
                                            onClick={() => {
                                              cancelPositition(it.idTurnoAgenda, user.idUsuario);
                                            }}
                                            style={{ backgroundColor: '#7a7a7a', color: 'white' }}
                                          >
                                            {user.siglaNomeUsuario}

                                          </Block>
                                        ));
                                      }
                                    })}
                                    {item.turnosAgenda.map((it) => {
                                      if (it.codigoDiaSemana === 4 && it.codigoTipoTurno === 1) {
                                        const position = Array(
                                          it.quantidadePosicoesDisponiveis,
                                        ).fill(null);
                                        if (position.length > 0) {
                                          return position.map((_) => (
                                            <Block onClick={() => {
                                              setIdTurnoAgenda(it.idTurnoAgenda);
                                              setOpenSchedule(true);
                                            }}
                                            >
                                              {' '}

                                            </Block>
                                          ));
                                        }
                                      }
                                    })}
                                  </ContainerColumBlock>
                                  <ContainerColumBlock>
                                    {item.turnosAgenda.map((it) => {
                                      if (it.codigoDiaSemana === 4 && it.codigoTipoTurno === 2) {
                                        const users = it.usuarios;
                                        return users.map((user) => (
                                          <Block
                                            onClick={() => {
                                              cancelPositition(it.idTurnoAgenda, user.idUsuario);
                                            }}
                                            style={{ backgroundColor: '#7a7a7a', color: 'white' }}
                                          >
                                            {user.siglaNomeUsuario}

                                          </Block>
                                        ));
                                      }
                                    })}
                                    {item.turnosAgenda.map((it) => {
                                      if (it.codigoDiaSemana === 4 && it.codigoTipoTurno === 2) {
                                        const position = Array(
                                          it.quantidadePosicoesDisponiveis,
                                        ).fill(null);
                                        if (position.length > 0) {
                                          return position.map((_) => (
                                            <Block onClick={() => {
                                              setIdTurnoAgenda(it.idTurnoAgenda);
                                              setOpenSchedule(true);
                                            }}
                                            >
                                              {' '}

                                            </Block>
                                          ));
                                        }
                                      }
                                    })}
                                  </ContainerColumBlock>
                                  <ContainerColumBlock>
                                    {item.turnosAgenda.map((it) => {
                                      if (it.codigoDiaSemana === 4 && it.codigoTipoTurno === 3) {
                                        const users = it.usuarios;
                                        return users.map((user) => (
                                          <Block
                                            onClick={() => {
                                              cancelPositition(it.idTurnoAgenda, user.idUsuario);
                                            }}
                                            style={{ backgroundColor: '#7a7a7a', color: 'white' }}
                                          >
                                            {user.siglaNomeUsuario}

                                          </Block>
                                        ));
                                      }
                                    })}
                                    {item.turnosAgenda.map((it) => {
                                      if (it.codigoDiaSemana === 4 && it.codigoTipoTurno === 3) {
                                        const position = Array(
                                          it.quantidadePosicoesDisponiveis,
                                        ).fill(null);
                                        if (position.length > 0) {
                                          return position.map((_) => (
                                            <Block onClick={() => {
                                              setIdTurnoAgenda(it.idTurnoAgenda);
                                              setOpenSchedule(true);
                                            }}
                                            >
                                              {' '}

                                            </Block>
                                          ));
                                        }
                                      }
                                    })}
                                  </ContainerColumBlock>
                                </DayByTurnContainer>
                              </ContainerBlocok>
                              {/* SEX */}
                              <ContainerBlocok>
                                <DayByTurnContainer>
                                  <ContainerColumBlock>
                                    {item.turnosAgenda.map((it) => {
                                      if (it.codigoDiaSemana === 5 && it.codigoTipoTurno === 1) {
                                        const users = it.usuarios;
                                        return users.map((user) => (
                                          <Block
                                            onClick={() => {
                                              cancelPositition(it.idTurnoAgenda, user.idUsuario);
                                            }}
                                            style={{ backgroundColor: '#7a7a7a', color: 'white' }}
                                          >
                                            {user.siglaNomeUsuario}

                                          </Block>
                                        ));
                                      }
                                    })}
                                    {item.turnosAgenda.map((it) => {
                                      if (it.codigoDiaSemana === 5 && it.codigoTipoTurno === 1) {
                                        const position = Array(
                                          it.quantidadePosicoesDisponiveis,
                                        ).fill(null);
                                        if (position.length > 0) {
                                          return position.map((_) => (
                                            <Block onClick={() => {
                                              setIdTurnoAgenda(it.idTurnoAgenda);
                                              setOpenSchedule(true);
                                            }}
                                            >
                                              {' '}

                                            </Block>
                                          ));
                                        }
                                      }
                                    })}
                                  </ContainerColumBlock>
                                  <ContainerColumBlock>
                                    {item.turnosAgenda.map((it) => {
                                      if (it.codigoDiaSemana === 5 && it.codigoTipoTurno === 2) {
                                        const users = it.usuarios;
                                        return users.map((user) => (
                                          <Block
                                            onClick={() => {
                                              cancelPositition(it.idTurnoAgenda, user.idUsuario);
                                            }}
                                            style={{ backgroundColor: '#7a7a7a', color: 'white' }}
                                          >
                                            {user.siglaNomeUsuario}

                                          </Block>
                                        ));
                                      }
                                    })}
                                    {item.turnosAgenda.map((it) => {
                                      if (it.codigoDiaSemana === 5 && it.codigoTipoTurno === 2) {
                                        const position = Array(
                                          it.quantidadePosicoesDisponiveis,
                                        ).fill(null);
                                        if (position.length > 0) {
                                          return position.map((_) => (
                                            <Block onClick={() => {
                                              setIdTurnoAgenda(it.idTurnoAgenda);
                                              setOpenSchedule(true);
                                            }}
                                            >
                                              {' '}

                                            </Block>
                                          ));
                                        }
                                      }
                                    })}
                                  </ContainerColumBlock>
                                  <ContainerColumBlock>
                                    {item.turnosAgenda.map((it) => {
                                      if (it.codigoDiaSemana === 5 && it.codigoTipoTurno === 3) {
                                        const users = it.usuarios;
                                        return users.map((user) => (
                                          <Block
                                            onClick={() => {
                                              cancelPositition(it.idTurnoAgenda, user.idUsuario);
                                            }}
                                            style={{ backgroundColor: '#7a7a7a', color: 'white' }}
                                          >
                                            {user.siglaNomeUsuario}

                                          </Block>
                                        ));
                                      }
                                    })}
                                    {item.turnosAgenda.map((it) => {
                                      if (it.codigoDiaSemana === 5 && it.codigoTipoTurno === 3) {
                                        const position = Array(
                                          it.quantidadePosicoesDisponiveis,
                                        ).fill(null);
                                        if (position.length > 0) {
                                          return position.map((_) => (
                                            <Block onClick={() => {
                                              setIdTurnoAgenda(it.idTurnoAgenda);
                                              setOpenSchedule(true);
                                            }}
                                            >
                                              {' '}

                                            </Block>
                                          ));
                                        }
                                      }
                                    })}
                                  </ContainerColumBlock>
                                </DayByTurnContainer>
                              </ContainerBlocok>
                              {/* SAB */}
                              <ContainerBlocok>
                                <DayByTurnContainer>
                                  <ContainerColumBlock>
                                    {item.turnosAgenda.map((it) => {
                                      if (it.codigoDiaSemana === 6 && it.codigoTipoTurno === 1) {
                                        const users = it.usuarios;
                                        return users.map((user) => (
                                          <Block
                                            onClick={() => {
                                              cancelPositition(it.idTurnoAgenda, user.idUsuario);
                                            }}
                                            style={{ backgroundColor: '#7a7a7a', color: 'white' }}
                                          >
                                            {user.siglaNomeUsuario}

                                          </Block>
                                        ));
                                      }
                                    })}
                                    {item.turnosAgenda.map((it) => {
                                      if (it.codigoDiaSemana === 6 && it.codigoTipoTurno === 1) {
                                        const position = Array(
                                          it.quantidadePosicoesDisponiveis,
                                        ).fill(null);
                                        if (position.length > 0) {
                                          return position.map((_) => (
                                            <Block onClick={() => {
                                              setIdTurnoAgenda(it.idTurnoAgenda);
                                              setOpenSchedule(true);
                                            }}
                                            >
                                              {' '}

                                            </Block>
                                          ));
                                        }
                                      }
                                    })}
                                  </ContainerColumBlock>
                                  <ContainerColumBlock>
                                    {item.turnosAgenda.map((it) => {
                                      if (it.codigoDiaSemana === 6 && it.codigoTipoTurno === 2) {
                                        const users = it.usuarios;
                                        return users.map((user) => (
                                          <Block
                                            onClick={() => {
                                              cancelPositition(it.idTurnoAgenda, user.idUsuario);
                                            }}
                                            style={{ backgroundColor: '#7a7a7a', color: 'white' }}
                                          >
                                            {user.siglaNomeUsuario}

                                          </Block>
                                        ));
                                      }
                                    })}
                                    {item.turnosAgenda.map((it) => {
                                      if (it.codigoDiaSemana === 6 && it.codigoTipoTurno === 2) {
                                        const position = Array(
                                          it.quantidadePosicoesDisponiveis,
                                        ).fill(null);
                                        if (position.length > 0) {
                                          return position.map((_) => (
                                            <Block onClick={() => {
                                              setIdTurnoAgenda(it.idTurnoAgenda);
                                              setOpenSchedule(true);
                                            }}
                                            >
                                              {' '}

                                            </Block>
                                          ));
                                        }
                                      }
                                    })}
                                  </ContainerColumBlock>
                                  <ContainerColumBlock>
                                    {item.turnosAgenda.map((it) => {
                                      if (it.codigoDiaSemana === 6 && it.codigoTipoTurno === 3) {
                                        const users = it.usuarios;
                                        return users.map((user) => (
                                          <Block
                                            onClick={() => {
                                              cancelPositition(it.idTurnoAgenda, user.idUsuario);
                                            }}
                                            style={{ backgroundColor: '#7a7a7a', color: 'white' }}
                                          >
                                            {user.siglaNomeUsuario}

                                          </Block>
                                        ));
                                      }
                                    })}
                                    {item.turnosAgenda.map((it) => {
                                      if (it.codigoDiaSemana === 6 && it.codigoTipoTurno === 3) {
                                        const position = Array(
                                          it.quantidadePosicoesDisponiveis,
                                        ).fill(null);
                                        if (position.length > 0) {
                                          return position.map((_) => (
                                            <Block onClick={() => {
                                              setIdTurnoAgenda(it.idTurnoAgenda);
                                              setOpenSchedule(true);
                                            }}
                                            >
                                              {' '}

                                            </Block>
                                          ));
                                        }
                                      }
                                    })}
                                  </ContainerColumBlock>
                                </DayByTurnContainer>
                              </ContainerBlocok>
                              {/* DOM */}
                              <ContainerBlocok>
                                <DayByTurnContainer>
                                  <ContainerColumBlock>
                                    {item.turnosAgenda.map((it) => {
                                      if (it.codigoDiaSemana === 0 && it.codigoTipoTurno === 1) {
                                        const users = it.usuarios;
                                        return users.map((user) => (
                                          <Block
                                            onClick={() => {
                                              cancelPositition(it.idTurnoAgenda, user.idUsuario);
                                            }}
                                            style={{ backgroundColor: '#7a7a7a', color: 'white' }}
                                          >
                                            {user.siglaNomeUsuario}

                                          </Block>
                                        ));
                                      }
                                    })}
                                    {item.turnosAgenda.map((it) => {
                                      if (it.codigoDiaSemana === 0 && it.codigoTipoTurno === 1) {
                                        const position = Array(
                                          it.quantidadePosicoesDisponiveis,
                                        ).fill(null);
                                        if (position.length > 0) {
                                          return position.map((_) => (
                                            <Block onClick={() => {
                                              setIdTurnoAgenda(it.idTurnoAgenda);
                                              setOpenSchedule(true);
                                            }}
                                            >
                                              {' '}

                                            </Block>
                                          ));
                                        }
                                      }
                                    })}
                                  </ContainerColumBlock>
                                  <ContainerColumBlock>
                                    {item.turnosAgenda.map((it) => {
                                      if (it.codigoDiaSemana === 0 && it.codigoTipoTurno === 2) {
                                        const users = it.usuarios;
                                        return users.map((user) => (
                                          <Block
                                            onClick={() => {
                                              cancelPositition(it.idTurnoAgenda, user.idUsuario);
                                            }}
                                            style={{ backgroundColor: '#7a7a7a', color: 'white' }}
                                          >
                                            {user.siglaNomeUsuario}

                                          </Block>
                                        ));
                                      }
                                    })}
                                    {item.turnosAgenda.map((it) => {
                                      if (it.codigoDiaSemana === 0 && it.codigoTipoTurno === 2) {
                                        const position = Array(
                                          it.quantidadePosicoesDisponiveis,
                                        ).fill(null);
                                        if (position.length > 0) {
                                          return position.map((_) => (
                                            <Block onClick={() => {
                                              setIdTurnoAgenda(it.idTurnoAgenda);
                                              setOpenSchedule(true);
                                            }}
                                            >
                                              {' '}

                                            </Block>
                                          ));
                                        }
                                      }
                                    })}
                                  </ContainerColumBlock>
                                  <ContainerColumBlock>
                                    {item.turnosAgenda.map((it) => {
                                      if (it.codigoDiaSemana === 0 && it.codigoTipoTurno === 3) {
                                        const users = it.usuarios;
                                        return users.map((user) => (
                                          <Block
                                            onClick={() => {
                                              cancelPositition(it.idTurnoAgenda, user.idUsuario);
                                            }}
                                            style={{ backgroundColor: '#7a7a7a', color: 'white' }}
                                          >
                                            {user.siglaNomeUsuario}

                                          </Block>
                                        ));
                                      }
                                    })}
                                    {item.turnosAgenda.map((it) => {
                                      if (it.codigoDiaSemana === 0 && it.codigoTipoTurno === 3) {
                                        const position = Array(
                                          it.quantidadePosicoesDisponiveis,
                                        ).fill(null);
                                        if (position.length > 0) {
                                          return position.map((_) => (
                                            <Block onClick={() => {
                                              setIdTurnoAgenda(it.idTurnoAgenda);
                                              setOpenSchedule(true);
                                            }}
                                            >
                                              {' '}

                                            </Block>
                                          ));
                                        }
                                      }
                                    })}
                                  </ContainerColumBlock>
                                </DayByTurnContainer>
                              </ContainerBlocok>
                              {/* SEGU */}
                              <ContainerBlocok>
                                <DayByTurnContainer>
                                  <ContainerColumBlock>
                                    {item.turnosAgenda.map((it) => {
                                      if (it.codigoDiaSemana === 1 && it.codigoTipoTurno === 1) {
                                        const users = it.usuarios;
                                        return users.map((user) => (
                                          <Block
                                            onClick={() => {
                                              cancelPositition(it.idTurnoAgenda, user.idUsuario);
                                            }}
                                            style={{ backgroundColor: '#7a7a7a', color: 'white' }}
                                          >
                                            {user.siglaNomeUsuario}
                                          </Block>
                                        ));
                                      }
                                    })}
                                    {item.turnosAgenda.map((it) => {
                                      if (it.codigoDiaSemana === 1 && it.codigoTipoTurno === 1) {
                                        const position = Array(
                                          it.quantidadePosicoesDisponiveis,
                                        ).fill(null);
                                        if (position.length > 0) {
                                          return position.map((_) => (
                                            <Block onClick={() => {
                                              setIdTurnoAgenda(it.idTurnoAgenda);
                                              setOpenSchedule(true);
                                            }}
                                            >
                                              {' '}
                                            </Block>
                                          ));
                                        }
                                      }
                                    })}
                                  </ContainerColumBlock>
                                  <ContainerColumBlock>
                                    {item.turnosAgenda.map((it) => {
                                      if (it.codigoDiaSemana === 1 && it.codigoTipoTurno === 2) {
                                        const users = it.usuarios;
                                        return users.map((user) => (
                                          <Block
                                            onClick={() => {
                                              cancelPositition(it.idTurnoAgenda, user.idUsuario);
                                            }}
                                            style={{ backgroundColor: '#7a7a7a', color: 'white' }}
                                          >
                                            {user.siglaNomeUsuario}

                                          </Block>
                                        ));
                                      }
                                    })}
                                    {item.turnosAgenda.map((it) => {
                                      if (it.codigoDiaSemana === 1 && it.codigoTipoTurno === 2) {
                                        const position = Array(
                                          it.quantidadePosicoesDisponiveis,
                                        ).fill(null);
                                        if (position.length > 0) {
                                          return position.map((_) => (
                                            <Block onClick={() => {
                                              setIdTurnoAgenda(it.idTurnoAgenda);
                                              setOpenSchedule(true);
                                            }}
                                            >
                                              {' '}

                                            </Block>
                                          ));
                                        }
                                      }
                                    })}
                                  </ContainerColumBlock>
                                  <ContainerColumBlock>
                                    {item.turnosAgenda.map((it) => {
                                      if (it.codigoDiaSemana === 1 && it.codigoTipoTurno === 3) {
                                        const users = it.usuarios;
                                        return users.map((user) => (
                                          <Block
                                            onClick={() => {
                                              cancelPositition(it.idTurnoAgenda, user.idUsuario);
                                            }}
                                            style={{ backgroundColor: '#7a7a7a', color: 'white' }}
                                          >
                                            {user.siglaNomeUsuario}

                                          </Block>
                                        ));
                                      }
                                    })}
                                    {item.turnosAgenda.map((it) => {
                                      if (it.codigoDiaSemana === 1 && it.codigoTipoTurno === 3) {
                                        const position = Array(
                                          it.quantidadePosicoesDisponiveis,
                                        ).fill(null);
                                        if (position.length > 0) {
                                          return position.map((_) => (
                                            <Block onClick={() => {
                                              setIdTurnoAgenda(it.idTurnoAgenda);
                                              setOpenSchedule(true);
                                            }}
                                            >
                                              {' '}

                                            </Block>
                                          ));
                                        }
                                      }
                                    })}
                                  </ContainerColumBlock>
                                </DayByTurnContainer>
                              </ContainerBlocok>
                            </DayContainer>
                          </ScheduleContainer>
                        ))}
                      </ScheduleContainerColumn>
                    </ScheduleContainerColumn>
                  </CardContainer>
                ) : (
                  <>
                    <div style={{ display: 'flex', flexDirection: 'row', marginLeft: option === 10 ? 20 : 0 }}>
                      <FormControl variant="outlined" style={{ width: '30%', marginTop: 80 }}>
                        <InputLabel id="demo-simple-select-outlined-label">Filtro</InputLabel>
                        <Select
                          labelId="demo-simple-select-outlined-label"
                          id="demo-simple-select-outlined"
                          value={option}
                          defaultValue={option}
                          onChange={handleChange}
                          label="Age"
                        >
                          <MenuItem value="">
                            <em />
                          </MenuItem>
                          <MenuItem value={10}>Reserva</MenuItem>
                          <MenuItem value={20}>Lista de corretores</MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                    <Corretores data={corretores || []} />
                  </>
                )}
              </>
            )}
          </div>
        </Container>
      </ContainerExt>
    </>
  );
};
export default Schedule;
